<script setup>

import Button from "@/components/common/input/Button";
import UploadedFileSave from "@/classes/global/UploadedFileSave";

import {ref, computed} from 'vue';

const uploadButton = ref();
const uploadFileSizeError = ref();

let uploadFileSizeErrorMessage = ref();

const updateFileInput = computed(() => {

  return props.modelValue.files.length
})

const props = defineProps({

  modelValue: {}
})

function handleUpload() {

  uploadButton.value.click()
}

async function handleUploadedFiles(files) {

  for(const file of files) {

    uploadFileSizeError.value = false;

    // Convert file size from bytes to megabytes
    let fileSize = Math.round((file.size / 1024 / 1024) * 100) / 100;

    if(fileSize < 28) {

      let prepareFile = new UploadedFileSave();

      prepareFile.fileName = file.name
      prepareFile.file = await getAsByteArray(file)

      props.modelValue.files.push(prepareFile)

    } else {

      uploadFileSizeError.value = true;
      uploadFileSizeErrorMessage.value = file.name + ' ' + 'is too large to upload - max 28MB'

    }

  }

}

async function getAsByteArray(file) {

  return new Uint8Array(await readFile(file))
}

function readFile(file) {

  return new Promise((resolve, reject) => {
    // Create file reader
    let reader = new FileReader()

    // Register event listeners
    reader.addEventListener("loadend", e => resolve(e.target.result))
    reader.addEventListener("error", reject)

    // Read file
    reader.readAsArrayBuffer(file)
  })
}

function handleRemoveDocument(index) {

  props.modelValue.files.splice(index, 1);

}

</script>

<template class="cmp-document-upload">
<div class="cmp-document-upload_wrapper">
  <div>
    <input :key="updateFileInput" v-show="false" ref="uploadButton" type="file" accept=".txt,.pdf,.png"
           multiple @change="handleUploadedFiles($event.target.files)"/>
    <Button
        @click="handleUpload"
        type="toolbar"
        text="Select">
    </Button>
    <span style="margin-left: 20px; font-size: 11px;">
    You may add multiple files by using ctrl and click in the file window</span>
  </div>
  <div v-if="uploadFileSizeError" class="cmp-document-upload_file-error-area">
    {{uploadFileSizeErrorMessage}}
  </div>
  <div class="cmp-document-upload_headings">
    <div>Name</div>
  </div>
  <div class="cmp-document-upload_uploaded-files-list">
    <div v-for="(item, index) in props.modelValue.files" class="cmp-document-upload_uploaded-files-items">
      <span><i class="fa-light fa-file" style="color: #719ece;"></i>  {{item.fileName}}</span>
      <div @click="handleRemoveDocument(index)">
        <i class="fa-sharp fa-solid fa-xmark" style="color: darkred; cursor: pointer; font-size: 20px;"></i>
      </div>
    </div>
    <div v-if="props.modelValue.files.length === 0" class="global-no-data-placeholder"
         style="display: flex; align-items: center; justify-content: center; height: 96px; font-size: 12px;">
      No Current Documents
    </div>
  </div>
</div>

</template>

<style lang="scss" scoped>

.cmp-document-upload {

  &_wrapper {
    position: relative;
    padding:10px;
  }

  &_headings {
    font-size: 13px;
    margin: 20px 0 0 5px;
    display: grid;
    grid-template-columns: 300px
  }

  &_files {
    margin: 3px 0 0 5px!important;
  }

  &_uploaded-files-list {
    margin-top: 7px;
    padding: 5px;
    width: 500px;
    border: 1px solid var(--border-color);
    height: 130px;
    overflow: auto;
    background: #ffffff;
    border-radius: var(--rounded-corners);
  }

  &_uploaded-files-items {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f5f5f5;
    border-radius: 3px;
    padding: 3px 10px 3px 10px;
    margin-top: 3px;
    border-left: 5px solid #457728;
    height: 16px;
    font-size: 12px;
  }

  &_uploaded-files-items:hover {
    border-left: 5px solid #b13c3c;
  }

  &_file-error-area {
    position: absolute;
    top: 40px;
    left: 105px;
    font-size: 12px;
    color: #b71b1b;
  }
}
</style>
